import SurveyPreview from './SurveyPreview.jsx';

export default SurveyPreview;